import * as d3 from "d3";
import AbstractForceGenerator from "./AbstractForceGenerator";

export default class ChargeForceGenerator extends AbstractForceGenerator {
    // Public:
    constructor(cParams) {
        super();
        this.saveParams(cParams);
        this.createStrengthFunction();
    }

    compute() {
        let strengthFunc = this._strengthFunc;
        let distanceMax = this._distanceMax;
        let theta = this._theta;
        let force = d3
            .forceManyBody()
            .strength(strengthFunc)
            .distanceMax(distanceMax)
            .theta(theta);
        return force;
    }

    // Private:
    saveParams(cParams) {
        this._masterStrength = cParams.masterStrength;
        this._slaveStrength = cParams.slaveStrength;
        this._distanceMax = cParams.distanceMax;
        this._theta = cParams.theta;
    }

    createStrengthFunction() {
        let masterStrength = this._masterStrength;
        let slaveStrength = this._slaveStrength;
        let func = this.attachToDispatchingFunction(masterStrength, slaveStrength);
        this._strengthFunc = func;
    }
}
